import { HTMLProps, useState } from 'react';
import DropdownMenu, { DropdownMenuContent } from '../DropdownMenu';
import { DataActionDropdownItemType, DataActionDropdownProps } from './DataActions';

export type DataActionDropdownItemProps = DataActionDropdownItemType
    & {
        focusAndClose: () => void;
        onSelectitem: DataActionDropdownProps['onSelectitem'];
    };

const DataActionDropdownItem = (props: DataActionDropdownItemProps) => {
    const { type = 'button', label, id, onClick, focusAndClose, onSelectitem, ...rest } = props;

    if (type === 'button') {
        return <button id={id} onClick={(e) => {
            focusAndClose();
            onClick && onClick(e);
            onSelectitem && onSelectitem(props, e);
        }} {...rest as HTMLProps<HTMLButtonElement>} type='button'>{label}</button>
    } else if (type === 'a') {
        return <a id={id} onClick={(e) => {
            focusAndClose();
            onClick && onClick(e);
            onSelectitem && onSelectitem(props, e);
        }} {...rest as HTMLProps<HTMLAnchorElement>}>{label}</a>
    }

    return null;
}

export const DropdownMenuExample = (props: DataActionDropdownProps) => {
    const { items = [], onSelectitem, ...rest } = props
    const [isExpanded, setIsExpanded] = useState(false);
    return (
        <DropdownMenu
            {...rest}
            isExpanded={isExpanded}
            setExpanded={setIsExpanded}
            variant="LowEmphasisCompact"
        >
            {items.length > 0 && (
                <DropdownMenuContent>
                    {({ focusAndClose }) => (<ul>
                        {items.map((item, index) => (<li key={index}>
                            <DataActionDropdownItem {...item} focusAndClose={focusAndClose} onSelectitem={onSelectitem} />
                        </li>))}
                    </ul>)}
                </DropdownMenuContent>
            )}
        </DropdownMenu>
    )
}

export default DropdownMenuExample;